export default __webpack_public_path__ + "static/media/chevron-up.3ce5d055.svg";